export default "**Reservation deposit**\n\n{depositPayment} paid on {depositDate}\n";